// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"161":"product-details","353":"contact","385":"default-layout","594":"about","962":"home","983":"products"}[chunkId] + "." + {"161":"df7e6097","353":"df7e6097","385":"df7e6097","594":"df7e6097","962":"df7e6097","983":"df7e6097"}[chunkId] + ".css";
};